import React, { useMemo } from "react";
import USFlagImg from "asset/images/US.png";
import NGNFlagImg from "asset/images/Currency.svg";
import USDCIcon from "asset/icons/USDC.svg";
import USDTIcon from "asset/icons/USDT.svg";
import KESIcon from "asset/icons/KES.svg";
import GHSIcon from "asset/icons/GH.svg";
import { ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "component/ui/Dialog";
import NewBadge from "component/ui/NewBadge";
import { NewSearchInput, SearchInput } from "../TableSearchInput";

const allCurrencies = [
    { name: "US Dollar", code: "USD", flag: USFlagImg, isNew: true },
    // { name: "GB Pounds", code: "GBP", flag: GBPFlagImg },
  { name: "Naira", code: "NGN", flag: NGNFlagImg },
    // { name: "Euro", code: "EUR", flag: EUFlagImg },
    { name: "Kenyan Shillings", code: "KES", flag: KESIcon },
    { name: "Ghana Cedi", code: "GHS", flag: GHSIcon },
    { name: "USD Coin", code: "USDC", flag: USDCIcon },
    { name: "USD Tether", code: "USDT", flag: USDTIcon },
];

const NewWalletModal = ({ isOpen, onClose, wallets = [], onCurrencySelect }) => {
  const [searchQuery, setSearchQuery] = React.useState("");
  const existingCurrencyCodes = useMemo(
      () => wallets.map((wallet) => String(wallet.currency).toUpperCase()),
        [wallets]
    );

    const filteredCurrencies = useMemo(
        () => allCurrencies.filter((c) => !existingCurrencyCodes.includes(c.code)),
        [existingCurrencyCodes]
    );


  const handleSearchChange = (value) => {
    setSearchQuery(value);
  }

  const currencyListToShow = filteredCurrencies.filter((item) => {
    const searchTerm = searchQuery.toLowerCase();
    return (
      item.code.toLowerCase().includes(searchTerm) ||
      item.name.toLowerCase().includes(searchTerm)
    );
  })

    if (!isOpen) return null;

    return (
      <Dialog open={isOpen} onOpenChange={(open) => !open && onClose?.()}>
        <DialogContent
          showCloseButton={true}
          className="max-w-[480px] sm:max-w-[560px] p-4 rounded-[16px] bg-white border-0 shadow-2xl overflow-hidden"
        >
          <div className="space-y-2 flex flex-col gap-2 mb-2">
            <DialogTitle className="text-[20px] !mb-0 sm:text-[22px] font-bold text-[#101828] tracking-tight">
            Open a new wallet
          </DialogTitle>
            <DialogDescription className="text-[13px] !mt-0 sm:text-[14px] text-[#667085]">
            Choose a currency for your new wallet.
          </DialogDescription>
          </div>

          <div className="flex flex-col gap-[12px] max-h-[420px] min-h-[200px] overflow-y-auto">
            <NewSearchInput wrapperClassName="w-full max-w-auto h-[48px]" placeholder="Search currencies" value={searchQuery} onChange={handleSearchChange} />
            {currencyListToShow?.map(({ name, code, flag, isNew }) => (
                        <div
                            key={code}
                            onClick={() => {
                                onCurrencySelect(code);
                            }}
                className="flex justify-between items-center border border-[#EAECF0] hover:border-[#6F00FF] h-[76px] cursor-pointer hover:bg-[#F9FAFB] p-2 rounded-[8px] transition-all group"
                        >
                        <div className="flex items-center gap-3">
                          <img
                            src={flag}
                            alt={name}
                            className="w-9 h-9 rounded-full object-cover shrink-0"
                          />
                                <div>
                            <p className="font-semibold text-[#101828] text-[14px] sm:text-[15px] group-hover:text-[#6F00FF] transition-colors">
                              {name}
                            </p>
                            <p className="text-[12px] font-normal text-[#667085]">{code}</p>
                                </div>
                            </div>
                        <div className="flex items-center gap-3">
                                {isNew && <NewBadge />}
                          <ChevronRight className="w-4 h-4 text-[#98A2B3] group-hover:text-[#6F00FF] transition-colors" />
                            </div>
                        </div>
                    ))}
            {currencyListToShow?.length === 0 && (
              <p className="text-sm text-center text-[#667085] py-8">
                            You've already opened all available wallets.
                        </p>
                    )}
                </div>
        </DialogContent>
      </Dialog>
    );
};

export default NewWalletModal;
